<script>
import ShopEntry from '@/views/Entry/ShopEntry'

export default {
  mixins: [
    ShopEntry
  ],
  data () {
    return {
      // 新規登録モードOFF
      newEntry: false
    }
  }
}
</script>
